// Spanish — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const es = {
  "uploadTitle": "Sube fotos del espacio",
  "uploadHint": "Haz clic o arrastra imágenes aquí",
  "uploadHintTouch": "Toca para elegir fotos",
  "uploadOr": "o",
  "takePhoto": "Tomar foto",
  "yourPhotos": "Tus fotos",
  "photoLabel": "Foto {n}",
  "photoCount": "{n} fotos",
  "addPhoto": "Añadir foto",
  "continue": "Continuar",
  "stepLabel": "Paso {current} de {total}",
  "chooseStyle": "Elige un estilo",
  "describeCustomStyle": "Describe tu estilo personalizado",
  "uploadReferenceTitle": "Sube una foto de referencia",
  "uploadReferenceHint": "La IA imitará sus tonos, materiales y ambiente — tu foto original no cambia.",
  "removeReference": "Quitar referencia",
  "cleanupOptionTidy": "Ordenar",
  "cleanupOptionTidyDesc": "Los muebles se quedan; se elimina el desorden y la basura",
  "cleanupOptionEmpty": "Vaciar la habitación",
  "cleanupOptionEmptyDesc": "Quita muebles y decoración. Paredes y suelo se quedan",
  "cleanupChooseOption": "Elige cómo limpiar",
  "layoutOptionFlow": "Mejor circulación",
  "layoutOptionFlowDesc": "Pasos más despejados — moverse resulta más fácil",
  "layoutOptionSpacious": "Más amplio",
  "layoutOptionSpaciousDesc": "Despeja las vistas — la habitación parece más grande",
  "planChooseOption": "¿Qué creamos a partir de tu plano?",
  "planOption_3d": "Plano 3D",
  "planOption_3dDesc": "Toda la casa desde arriba, amueblada en el estilo que elijas",
  "planOption_room": "Una estancia",
  "planOption_roomDesc": "Pinta una estancia en el plano y mírala a la altura de los ojos",
  "planOption_clean": "Pasar a limpio el plano",
  "planOption_cleanDesc": "Un boceto o plano borroso, redibujado con claridad",
  "planCleanKindTitle": "Tipo de dibujo",
  "planCleanKind_line": "Blanco y negro",
  "planCleanKind_color": "Plano a color",
  "planStyleTitle": "Estilo",
  "planRoomTitle": "¿Qué estancia?",
  "planRoomSignIn": "Inicia sesión para elegir una estancia en tu plano.",
  "planRoomPaint": "Pinta la estancia en el plano",
  "planRoomPicked": "Estancia elegida",
  "planRoomRepaint": "Pintar de nuevo",
  "planRoomClear": "Borrar",
  "planRoomNamePlaceholder": "O escribe el nombre (ej. dormitorio principal)",
  "planCropHint": "Recorta la foto solo con el plano para un resultado más preciso.",
  "planFirstOnly": "Solo se usa la primera foto como plano.",
  "planRoomPickTitle": "Elige una estancia",
  "planRoomPickHint": "Pinta sobre la estancia que quieras ver. Un trazo aproximado basta.",
  "planRoomPickDone": "Usar esta estancia",
  "planRoomNeedPick": "Pinta una estancia en el plano o escribe su nombre.",
  "errNotFloorplan": "No parece un plano. Sube un plano o elige un estilo.",
  "planRoomFrom": "Estancia elegida en el plano",
  "planInputLabel": "Plano",
  "planOutput_plan_3d": "Plano 3D",
  "planOutput_plan_room": "Vista de la estancia",
  "planOutput_plan_clean": "Plano en limpio",
  "planOutput_plan_color": "Plano a color",
  "planRoomFromResult": "Ver una estancia",
  "planRoomMake": "Crear esta estancia",
  "planRoomMeta": "{n} créditos · esta estancia a la altura de los ojos, misma casa",
  "layoutChooseOption": "Elige cómo reorganizar",
  "creditEarnHint": "Gana créditos entrando cada día (+1) o invitando amigos (+5).",
  "languageHint": "También se usa para el análisis del diseño.",
  "reuseStyle": "— Reutilizar un estilo anterior —",
  "customPlaceholder": "Describe el estilo que quieres (ej. «cabaña acogedora en tonos madera», «minimalismo futurista con acentos metálicos»)",
  "customStylePublicHint": "El texto de tu estilo puede aparecer de forma anónima en la comunidad. Se puede desactivar en Ajustes.",
  "communityRankTitle": "Estilos en tendencia",
  "communityPeople": "{n} personas",
  "customStylesChip": "Estilos personalizados",
  "galleryRecentBadge": "Recién usado",
  "timeJustNow": "ahora mismo",
  "timeAgoMin": "hace {n} min",
  "timeAgoHour": "hace {n} h",
  "communityViewAll": "Ver todo",
  "galleryTitle": "Estilos en tendencia",
  "briefsLabel": "Novedades",
  "briefTopupKicker": "Créditos",
  "briefTopupTitle": "No tienes suficientes créditos para el próximo diseño",
  "briefTopupLine": "Tus créditos gratis se renuevan mañana. ¿Necesitas más ya? Consigue un pack.",
  "briefSeasonKicker": "De temporada",
  "briefSeasonTitle": "{name} ha llegado",
  "briefSeasonLine": "Un estilo de temporada, solo por unas semanas.",
  "briefInviteKicker": "Invitar",
  "briefInviteTitle": "Invita a un amigo: ambos recibís +{n} créditos",
  "briefInviteLine": "Comparte tu enlace. Los créditos llegarán cuando se registre.",
  "galleryEmpty": "Nada en tendencia por ahora — los estilos aparecen al empezar a usarse.",
  "galleryBuiltinTitle": "Ranking de estilos del momento",
  "galleryPopularCustom": "Estilos personalizados del momento",
  "galleryDiscoverTitle": "Descubre estilos personalizados",
  "galleryShuffle": "Mezclar",
  "galleryTranslate": "Traducir",
  "galleryTranslating": "Traduciendo…",
  "galleryOriginal": "Ver original",
  "galleryLiveTab": "En vivo",
  "galleryLiveWaiting": "Esperando nuevos estilos…",
  "galleryLiveTitle": "Usándose ahora mismo",
  "galleryRecentCustom": "Estilos personalizados recientes",
  "galleryUse": "Usar este estilo",
  "styleShareNotice": "El texto de tus estilos personalizados puede aparecer de forma anónima en la comunidad.",
  "styleShareNoticeSettings": "Desactivar en ajustes",
  "styleShareNoticeOk": "Entendido",
  "communityTopTitle": "Estilos personalizados populares",
  "communityRecentTitle": "Recién usados por otros",
  "communityUses": "Usado {n}×",
  "communityDesigns": "{n} diseños",
  "communityDesignsOne": "{n} diseño",
  "styleShareTitle": "Compartir mis estilos personalizados",
  "styleShareDesc": "Otros pueden descubrir y probar el texto de tus estilos. Tus fotos nunca se comparten.",
  "additionalRequests": "Peticiones adicionales",
  "optional": "(opcional)",
  "additionalPlaceholder": "¿Algo concreto para tu diseño {style}? (ej. «añade una mesa de centro de madera», «acento verde azulado»)",
  "addAdditionalRequest": "+ Añadir peticiones concretas",
  "generateDesign": "Generar diseño",
  "back": "Atrás",
  "generatingOne": "La IA está generando tu diseño de interior…",
  "generatingMany": "La IA está generando {n} diseños coherentes para tu espacio…",
  "generatingOneExterior": "La IA está generando tu nueva fachada…",
  "generatingManyExterior": "La IA está generando {n} renders exteriores coherentes…",
  "generatingOneGarden": "La IA está generando tu nuevo jardín…",
  "generatingManyGarden": "La IA está generando {n} renders de jardín coherentes…",
  "generationFailed": "La generación falló",
  "tryAgain": "Reintentar",
  "errNoInternet": "Sin conexión a Internet. Comprueba tu red e inténtalo de nuevo.",
  "errTimeout": "La IA tardó demasiado en responder. Inténtalo de nuevo.",
  "errTooMany": "Demasiadas solicitudes. Espera un momento e inténtalo de nuevo.",
  "errNetwork": "Error de red. Comprueba tu conexión e inténtalo de nuevo.",
  "errAI": "El servicio de diseño IA tuvo un problema. Inténtalo de nuevo.",
  "errFileType": "Tipo de archivo no compatible. Sube una imagen JPEG, PNG o WebP.",
  "errFileTooLarge": "El archivo es demasiado grande. Sube una imagen de menos de 20 MB.",
  "errPhotoRead": "No se pudo leer esa foto. Intenta con otra.",
  "errCameraAccess": "Sin acceso a la cámara. Permite el acceso en Ajustes.",
  "errCameraCapture": "No se pudo tomar la foto. Intenta de nuevo.",
  "errCaptionSave": "No se pudo guardar el pie de foto. Intenta de nuevo.",
  "imageUnavailable": "Imagen no disponible",
  "designShareText": "Mira este diseño {style} hecho con archelier",
  "altPhoto": "Foto {n}",
  "altOriginal": "Original {n}",
  "altGenerated": "Diseño {n}",
  "errInvalidSpace": "No pudimos reconocer un espacio. Usa una foto que muestre una habitación — pared y suelo juntos, o una esquina.",
  "pickAnotherPhoto": "Elegir otra foto",
  "errCustomStyle": "Describe tu estilo personalizado.",
  "errSignIn": "Error al iniciar sesión. Inténtalo de nuevo.",
  "errInsufficientCredits": "Te quedaste sin créditos. Vuelve mañana por tu bono diario.",
  "creditCostHint": "{n} fotos usan {c} créditos — {p} por foto.",
  "errCreditsShort": "Necesitas {need} créditos y tienes {have}. Quita una foto o invita a un amigo para conseguir más.",
  "credits": "Créditos",
  "creditsOne": "{n} crédito",
  "creditsMany": "{n} créditos",
  "outOfCredits": "Sin créditos",
  "creditModalTitle": "Consigue más créditos",
  "creditModalDesc": "Tus créditos diarios vuelven mañana. ¿Necesitas más antes?",
  "creditModalWallDesc": "Esos son los diseños gratis de hoy. Mañana vuelven {n} más — o recarga ahora para seguir.",
  "errOutOfCreditsToday": "Te quedaste sin créditos por hoy. Mañana vuelven {n} diseños gratis — o recarga para seguir.",
  "lastFreeHint": "Ese fue el último diseño gratis de hoy. {n} más mañana.",
  "lastFreeHintCta": "Recarga ahora",
  "creditModalChatFree": "Chatear con Gio, tu diseñador, sigue siendo gratis.",
  "creditModalGuestTitle": "Inicia sesión para seguir creando",
  "creditModalGuestDesc": "Con una cuenta recibes créditos gratis cada día, y puedes guardar y compartir.",
  "creditOptionSignIn": "Iniciar sesión y continuar",
  "creditOptionSignInDesc": "Empieza en un segundo con Google o Apple",
  "creditOptionInvite": "Invitar a un amigo",
  "creditOptionInviteDesc": "Ambos reciben +{n} créditos cuando se registre",
  "comingSoon": "Próximamente",
  "close": "Cerrar",
  "getAppTitle": "archelier",
  "getAppDesc": "Rediseña tu espacio en la app",
  "getAppCta": "Obtener",
  "appGateTitle": "Continúa en la app",
  "appGateDesc": "Diseñar va mejor en la app: cámara, diseños guardados y resultados más rápidos.",
  "appGateCta": "Descargar la app",
  "appGateNotNow": "Ahora no",
  "dailyBonusHint": "Recibes {n} créditos gratis cada día.",
  "creditsAria": "{n} créditos restantes",
  "accountCreditsTitle": "Créditos",
  "creditsDailyLabel": "Diarios, se reinician a medianoche",
  "creditsBonusLabel": "Bonus, no caducan",
  "creditsResetHint": "Recibes {n} créditos gratis cada día. Los bonus por invitación se quedan hasta que los uses.",
  "creditsInviteCta": "Invita a un amigo y gana +{n}",
  "creditsTopUpCta": "Comprar créditos",
  "inviteMenu": "Invitar amigos",
  "profileShare": "Compartir",
  "profileShareText": "Mira los diseños de {name} en archelier.",
  "original": "Original",
  "aiDesign": "Diseño IA",
  "imageGenFailed": "La generación de imagen falló para esta foto",
  "seeAnalysis": "Consulta el análisis del diseño abajo.",
  "analysisTitle": "Análisis del diseño de interior",
  "spaceAnalysis": "Análisis del espacio",
  "styleDescription": "Descripción del estilo",
  "colorPalette": "Paleta de colores",
  "furnitureRec": "Muebles recomendados",
  "shopFor": "Buscar {item}",
  "shopShort": "Comprar",
  "paintMatch": "Pintura más parecida",
  "paintCodeCopy": "Copiar código de pintura",
  "paintCodeCopied": "Código copiado",
  "editRegion": "Editar una zona",
  "editRegionTitle": "Edita este diseño",
  "editRegionDesc": "Dile a la IA qué cambiar y qué poner en su lugar. El resto no cambia.",
  "editRegionBrushHint": "Dile a la IA qué cambiar o añadir. Para modificar una zona, píntala primero; de lo contrario, editará toda la imagen. Para quitar algo, píntalo y escribe «quítalo».",
  "editRegionMeta": "Guardado como nuevo diseño · {n} créditos",
  "editedFromBanner": "Esta es una copia editada.",
  "viewOriginal": "Ver original",
  "editsOfThisDesign": "Ediciones de este diseño",
  "editsOfThisDesignDesc": "Diseños creados editando partes de este.",
  "chatTitle": "Asesor de diseño IA",
  "chatHint": "Haz preguntas sobre este espacio. La IA ve tu diseño y se basa en él.",
  "chatStart": "Iniciar conversación",
  "chatPlaceholder": "Pregunta por un mueble, color o distribución…",
  "chatSend": "Enviar",
  "chatSending": "Pensando…",
  "chatSuggestion1": "¿Qué lámpara haría este espacio más cálido?",
  "chatSuggestion2": "¿Cómo hacerlo parecer más amplio?",
  "chatSuggestion3": "¿Qué 3 cosas cambio primero?",
  "chatTurnsRemaining": "{n} turnos restantes en este diseño",
  "chatTurnsExhausted": "Alcanzaste el límite de chat de este diseño. Crea uno nuevo para seguir.",
  "chatErrGeneric": "El asesor no pudo responder. Inténtalo de nuevo.",
  "chatPro": "Pro — chat ilimitado",
  "chatRetry": "Reintentar",
  "commentsTitle": "Comentarios",
  "commentPlaceholder": "Añade un comentario",
  "commentPost": "Publicar",
  "commentPosting": "Publicando…",
  "commentSignInHint": "Inicia sesión para comentar.",
  "commentEmpty": "Aún no hay comentarios.",
  "commentDelete": "Eliminar",
  "commentDeleteConfirm": "¿Eliminar este comentario?",
  "commentTooLong": "Los comentarios están limitados a 500 caracteres.",
  "commentErrGeneric": "No se pudo publicar el comentario. Inténtalo de nuevo.",
  "commentCount": "{n}",
  "bookmarksTitle": "Mis colecciones",
  "tabDesigns": "Diseños",
  "tabCollections": "Colecciones",
  "bookmarksSectionTitle": "Diseños guardados",
  "bookmarksEmpty": "Aún no hay colecciones. Guarda un diseño para crear un tablero.",
  "bookmarksAdd": "Guardar",
  "bookmarksAdded": "Guardado",
  "bookmarksRemove": "Quitar de guardados",
  "bookmarksSignInHint": "Inicia sesión para guardar diseños.",
  "saved": "Guardado",
  "savedCollectionDefault": "Guardados",
  "follow": "Seguir",
  "unfollow": "Dejar de seguir",
  "following": "Siguiendo",
  "followers": "Seguidores",
  "followingTab": "Siguiendo",
  "followingEmpty": "Sigue a gente para ver aquí sus últimos diseños.",
  "followersEmpty": "Aún no tienes seguidores.",
  "followingEmpty2": "Todavía no sigues a nadie.",
  "followSignInHint": "Inicia sesión para seguir",
  "cannotFollowSelf": "No puedes seguirte a ti mismo.",
  "profile": "Perfil",
  "profileNotFound": "Este perfil no existe.",
  "profileDesigns": "Diseños",
  "profileDesignsCount": "Diseños",
  "profileFollowers": "Seguidores",
  "profileFollowing": "Siguiendo",
  "profileBio": "Bio",
  "profileEdit": "Editar perfil",
  "profileMyProfile": "Mi perfil",
  "displayNameLabel": "Nombre visible",
  "displayNamePlaceholder": "Tu nombre o estudio (opcional)",
  "displayNameSave": "Guardar nombre",
  "displayNameSaved": "Nombre guardado",
  "displayNameErrGeneric": "No se pudo guardar el nombre. Inténtalo de nuevo.",
  "handleLabel": "Usuario",
  "handlePlaceholder": "minúsculas, números, guion bajo (3-20)",
  "handleSave": "Guardar usuario",
  "handleSaved": "Usuario guardado",
  "handleInvalid": "Debe tener 3-20 caracteres: a-z, 0-9, guion bajo.",
  "handleTaken": "Ese usuario ya está en uso.",
  "handleErrGeneric": "No se pudo guardar el usuario. Inténtalo de nuevo.",
  "bioPlaceholder": "Cuéntanos algo de ti (máx. 200 caracteres)",
  "bioSave": "Guardar bio",
  "bioSaved": "Bio guardada",
  "bioErrGeneric": "No se pudo guardar la bio. Inténtalo de nuevo.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "tu_usuario_de_instagram",
  "instagramInvalid": "Solo letras, números, punto o guion bajo (máx. 30).",
  "profileNoDesigns": "Aún no hay diseños.",
  "collections": "Colecciones",
  "collectionsTab": "Colecciones",
  "collectionMine": "Mis colecciones",
  "collectionEmpty": "Aún no hay colecciones.",
  "collectionPublicEmpty": "No hay colecciones públicas.",
  "collectionItemCount": "{n} elementos",
  "collectionEmpty2": "Esta colección está vacía.",
  "newCollection": "Nueva colección",
  "collectionNamePlaceholder": "Nombre (ej. Ideas para el salón)",
  "collectionCreate": "Crear",
  "collectionDelete": "Eliminar colección",
  "collectionDeleteConfirm": "¿Eliminar esta colección? Se quitarán sus elementos.",
  "collectionRename": "Renombrar colección",
  "collectionVisibility": "Colección pública",
  "collectionVisibilityOn": "Cualquiera con el enlace puede verla",
  "collectionVisibilityOff": "Solo tú puedes verla",
  "addToCollection": "Añadir a colección",
  "saveToCollection": "Guardar en colección",
  "collectionAdded": "Añadido",
  "collectionRemoveFromBoard": "Quitar de la colección",
  "collectionShareLink": "Copiar enlace de la colección",
  "collectionByOwner": "de",
  "collectionNotFound": "Esta colección no existe o es privada.",
  "collectionErrCreate": "No se pudo crear la colección.",
  "collectionErrSave": "No se pudo actualizar la colección.",
  "collectionDone": "Hecho",
  "collectionPickerHint": "Toca una colección para añadir o quitar este diseño.",
  "uploadAcceptsHint": "Las fotos funcionan mejor, pero también valen bocetos, alzados, planos y capturas 3D.",
  "examplePhotos": "Fotos de ejemplo",
  "detectedInputTypes": {
    "sketch": "Boceto",
    "elevation": "Alzado",
    "floorplan": "Plano",
    "3d_model": "Modelo 3D"
  },
  "floorplanDetectedBanner": "Parece un plano — se renderizó la zona común más grande a la altura de los ojos. Para una habitación concreta, añádelo como petición adicional la próxima vez (ej. «renderiza el dormitorio principal»).",
  "floorplanDetectedBannerWithRoom": "Parece un plano — se renderizó {room} a la altura de los ojos. Para otra habitación, añádelo como petición adicional la próxima vez.",
  "spaceCategoryTitle": "¿Qué vas a diseñar?",
  "spaceCategories": {
    "interior": "Interior",
    "exterior": "Exterior",
    "garden": "Jardín"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Calabazas, farolillos, porche otoñal"
    },
    "christmas": {
      "name": "Navidad",
      "description": "Coronas, luces cálidas, guirnalda de abeto"
    },
    "lunar_new_year": {
      "name": "Año Nuevo Lunar",
      "description": "Farolillos rojos, dorados, coplas de fortuna"
    },
    "spring_blossom": {
      "name": "Primavera en flor",
      "description": "Árboles en flor, plantas pastel, luz fresca"
    },
    "modern_facade": {
      "name": "Fachada moderna",
      "description": "Geometría limpia, grandes cristales, materiales mixtos"
    },
    "modern_farmhouse": {
      "name": "Farmhouse moderno",
      "description": "Revestimiento blanco, marcos negros, acentos de madera"
    },
    "mediterranean": {
      "name": "Mediterráneo",
      "description": "Estuco, terracota, arcos"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Tejas de madera, aleros bajos, vigas vistas"
    },
    "contemporary": {
      "name": "Contemporáneo",
      "description": "Líneas marcadas, volúmenes audaces, materiales industriales"
    },
    "minimalist_exterior": {
      "name": "Exterior minimalista",
      "description": "Paleta contenida, protagonismo de un solo material"
    },
    "tudor": {
      "name": "Tudor",
      "description": "Estilo Tudor inglés — entramado de madera y tejados inclinados"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Tradición de Nueva Inglaterra — teja blanca y contraventanas negras"
    },
    "japanese_traditional": {
      "name": "Japonés tradicional",
      "description": "Estructura de madera tipo minka, tejado de tejas, engawa"
    },
    "mountain_cabin": {
      "name": "Cabaña de montaña",
      "description": "A-frame de madera o troncos, en plena naturaleza"
    },
    "midcentury_exterior": {
      "name": "Exterior mid-century",
      "description": "Modernismo años 50-60 — tejado plano, grandes cristales"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Calabazas, farolillos, jardín otoñal"
    },
    "christmas": {
      "name": "Navidad",
      "description": "Abetos iluminados, luces cálidas, jardín invernal"
    },
    "lunar_new_year": {
      "name": "Año Nuevo Lunar",
      "description": "Farolillos rojos, ramas en flor, jardín de fortuna"
    },
    "spring_blossom": {
      "name": "Primavera en flor",
      "description": "Cerezos, tulipanes, verde primaveral"
    },
    "modern": {
      "name": "Jardín moderno",
      "description": "Geometría recortada, pavimento, gramíneas"
    },
    "mediterranean": {
      "name": "Mediterráneo",
      "description": "Grava, olivo y lavanda, macetas de barro"
    },
    "coastal": {
      "name": "Costero",
      "description": "Gramíneas, madera de deriva, plantas salinas"
    },
    "minimalist": {
      "name": "Minimalista",
      "description": "Un material, una paleta vegetal, vacío"
    },
    "zen": {
      "name": "Jardín zen",
      "description": "Grava rastrillada, piedras, plantas contadas"
    },
    "cottage": {
      "name": "Jardín cottage",
      "description": "Romántico, plantación densa, perennes variadas"
    },
    "desert": {
      "name": "Desierto / Xerojardín",
      "description": "Resistente a la sequía, suculentas, grava"
    },
    "tropical": {
      "name": "Tropical",
      "description": "Follaje exuberante, hojas grandes, flores vivas"
    },
    "english": {
      "name": "Jardín inglés",
      "description": "Césped cuidado, setos, borduras en capas"
    }
  },
  "seasonLabel": "Estación",
  "seasons": {
    "none": "Cualquiera",
    "spring": "Primavera",
    "summer": "Verano",
    "autumn": "Otoño",
    "winter": "Invierno"
  },
  "timeOfDayLabel": "Momento del día",
  "timesOfDay": {
    "none": "Cualquiera",
    "day": "Día",
    "golden_hour": "Hora dorada",
    "night": "Noche"
  },
  "editRegionReplacementLabel": "¿Qué quieres cambiar?",
  "editRegionReplacementPlaceholder": "ej.: añadir una estatua grande junto a la puerta",
  "editRegionSubmit": "Generar edición",
  "editRegionGenerating": "Generando imagen editada…",
  "editRegionMaskRequired": "Primero pinta la zona que quieres cambiar.",
  "editRegionReplacementRequired": "Dinos qué poner ahí.",
  "editRegionBrush": "Pincel",
  "editRegionUndo": "Deshacer",
  "editRegionSize": "Tamaño",
  "editRegionClear": "Restablecer",
  "errEditGeneric": "La edición falló. Inténtalo de nuevo.",
  "lightingPlan": "Plan de iluminación",
  "designTips": "Consejos de diseño",
  "startNew": "Nuevo diseño",
  "viewMyDesigns": "Ver mis diseños",
  "favorite": "Favorito",
  "unfavorite": "Quitar de favoritos",
  "rename": "Renombrar",
  "savePromptText": "Inicia sesión para conservar este diseño, compartirlo y crear más",
  "guestCreditsLeft": "Te queda {n} diseño gratis. Inicia sesión y empieza con {total}.",
  "guestCreditsGone": "Ese fue tu último diseño gratis. Inicia sesión y recibe {total}.",
  "signInGoogle": "Iniciar sesión con Google",
  "signInApple": "Iniciar sesión con Apple",
  "signInDesc": "Guarda tus diseños y accede a ellos cuando quieras.",
  "signInPopupBlocked": "El popup fue bloqueado. Permite popups en los ajustes del navegador.",
  "appName": "archelier",
  "navCreate": "Crear",
  "navGallery": "Galería",
  "navGio": "Diseñador",
  "navMain": "Navegación principal",
  "packsTitle": "Recargar",
  "packDesigns": "unos {n} diseños",
  "packBuying": "Abriendo…",
  "packWaiting": "Pago realizado — añadiendo tus créditos…",
  "packDone": "Créditos añadidos.",
  "packSlow": "Tus créditos están en camino. Aparecerán en breve — no necesitas comprar de nuevo.",
  "packFailed": "La compra no se completó. Si te cobraron y no llegan tus créditos, contacta con soporte.",
  "gioRole": "Diseñador de espacios",
  "gioAiNote": "IA",
  "gioSignInBody": "Inicia sesión para hablar con Gio. Gio mira las fotos de tus habitaciones y diseños anteriores, sugiere estilos y puede crear o editar un diseño desde el chat.",
  "gioGreeting": "Hola, soy Gio. Envíame una foto de tu espacio, una imagen o enlace de una habitación que te guste o uno de tus diseños — te sugeriré una idea y puedo crearlo para ti.",
  "gioChipTaste": "¿Cuál es mi estilo?",
  "gioChipTrend": "¿Qué es tendencia esta semana?",
  "gioChipPhoto": "Enviar foto de habitación",
  "gioChipMine": "Usar uno de mis diseños",
  "gioTyping": "Gio está pensando…",
  "gioPlaceholder": "Pregunta a Gio o pega un enlace",
  "gioSend": "Enviar",
  "gioAttachPhoto": "Adjuntar foto",
  "gioPickDesign": "Mis diseños",
  "gioPickEmpty": "Aún no hay diseños — crea uno primero y tráelo aquí.",
  "gioRemove": "Quitar",
  "gioToday": "Hoy",
  "gioNoCredits": "Te quedaste sin créditos.",
  "gioError": "Gio no pudo responder ahora. Inténtalo de nuevo.",
  "gioAlreadyStarting": "Ya está iniciando — espera un momento.",
  "gioPhotoSkipped": "No se pudieron añadir algunas fotos. Puedes adjuntar hasta {n} fotos (JPG, PNG, WebP o HEIC, de menos de 20 MB).",
  "gioErrPhotos": "No se encontraron las fotos para esto. Añade una foto de tu espacio e inténtalo de nuevo.",
  "gioErrPrompt": "Gio no pudo convertir eso en un diseño. Intenta describirlo de otra forma.",
  "gioErrGone": "Ese diseño o sugerencia ya no está disponible.",
  "gioCreditsLow": "Quedan {n} créditos · un mensaje usa {c}, {p} con foto",
  "gioCreditsLowFree": "Quedan {n} créditos · chatear con Gio es gratis",
  "gioNoCreditsChatFree": "Te quedaste sin créditos para diseños — chatear sigue siendo gratis.",
  "gioDailyLimit": "Es mucho chatear por un día. Sigamos mañana.",
  "gioCardEdit": "Editar",
  "gioCardPhotos": "Fotos listas: {n}",
  "gioCardPhotoFromDesign": "Foto de tu diseño del {date}",
  "gioCardPhotoFromDesignNoDate": "Foto de uno de tus diseños",
  "gioCardPhotoFromChat": "Foto que compartiste aquí",
  "gioCardPhotoNew": "Foto nueva",
  "gioCardNoPhoto": "Sin foto aún",
  "gioCardChangePhoto": "Cambiar",
  "gioCardAddPhoto": "Añadir foto",
  "gioCardUploading": "Subiendo…",
  "gioCardSame": "Ya tienes un diseño {style} de esta foto ({date}).",
  "gioCardSameView": "Ver",
  "gioCardSameHint": "Con la misma petición saldrá muy parecido. Para cambiarlo, añade una petición arriba, díselo a Gio en el chat o ábrelo en Crear.",
  "gioPickPhoto": "Elige una foto",
  "gioPickUpload": "Subir una foto nueva",
  "gioRunEdit": "Editar · {n} créditos",
  "gioRunGenerate": "Crear · {n} créditos",
  "gioRunWithPhoto": "Añadir foto y crear · {n}/foto",
  "gioOpenInCreate": "Abrir en Crear",
  "gioPaintMyself": "Pintar el área yo mismo",
  "gioStarting": "Iniciando…",
  "gioJobMaking": "Creando tu diseño…",
  "gioJobEditing": "Editando tu diseño…",
  "gioJobNotify": "Puedes salir — te avisaré cuando esté listo.",
  "gioJobInvalid": "Esa foto no parece un espacio que pueda diseñar.",
  "gioJobFailed": "No pude terminar este.",
  "gioJobRefunded": "Tus créditos han sido devueltos.",
  "gioJobDone": "Listo — echa un vistazo",
  "gioJobGone": "Este diseño fue eliminado.",
  "gioAskAboutDesign": "Pregunta a Gio sobre este diseño",
  "navFeed": "Feed",
  "navMy": "Mío",
  "navAccount": "Ajustes",
  "signIn": "Iniciar sesión",
  "signOut": "Cerrar sesión",
  "deleteAccount": "Eliminar cuenta",
  "deleteAccountTitle": "¿Eliminar tu cuenta?",
  "deleteAccountWarn": "Esto elimina permanentemente tu cuenta y todos los datos vinculados. No se puede deshacer.",
  "deleteAccountItem_designs": "Todos tus diseños, imágenes y conversaciones con Gio",
  "deleteAccountItem_profile": "Tu perfil, usuario y estilos guardados",
  "deleteAccountItem_social": "Comentarios, me gusta, seguidores y colecciones",
  "deleteAccountItem_credits": "Créditos restantes, incluidos los comprados, e historial de suscripción",
  "deleteAccountBilling_web": "Tu suscripción web activa se cancelará automáticamente.",
  "deleteAccountBilling_ios": "Tu suscripción a App Store o Google Play no se cancelará automáticamente — cancélala en los ajustes de suscripción de tu tienda.",
  "deleteAccountFinal": "Se cerrará tu sesión de inmediato y no podrás recuperar esta cuenta.",
  "deleteAccountConfirm": "Eliminar cuenta",
  "deleteAccountSubmitting": "Eliminando…",
  "deleteAccountError": "No se pudo eliminar la cuenta. Inténtalo de nuevo.",
  "myDesigns": "Mis diseños",
  "language": "Idioma",
  "support": "Soporte",
  "terms": "Términos del servicio",
  "privacy": "Política de privacidad",
  "signInTerms": "Al iniciar sesión aceptas nuestros {terms} y nuestra {privacy}.",
  "onboardingSkip": "Saltar",
  "onboardingNext": "Siguiente",
  "onboardingStart": "Empezar",
  "tourTitle": "Tour por archelier",
  "tourCreate": "Empieza aquí. Toma o sube una foto de una habitación, exterior o jardín, elige un estilo y tendrás un nuevo diseño en unos instantes.",
  "tourGallery": "Galería: los estilos más elegidos en archelier esta semana. Toca uno para probarlo en tu espacio.",
  "tourGio": "Gio es tu diseñador. Envale una foto y dile qué quieres: Gio te sugiere estilos y luego crea o edita el diseño para ti.",
  "tourMy": "Tus diseños se guardan en Mis diseños. Corrige solo una parte pincelándola o describiéndola, y luego descarga o comparte.",
  "tourStart": "Vuelve a este botón en cualquier momento para un nuevo diseño. Empecemos con una foto.",
  "tourReplay": "Repetir el tour",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Fotografía, boceta o sube",
      "desc": "Una foto del móvil basta, pero archelier también lee bocetos a mano, alzados, planos cenitales y capturas de modelos 3D — todo con detección automática."
    },
    {
      "icon": "style",
      "title": "19+ estilos, 4 modos inteligentes",
      "desc": "Elige un estilo, escribe un prompt propio, imita una foto de referencia o usa los modos Ordenar / Distribución."
    },
    {
      "icon": "brush",
      "title": "Edita solo la parte que quieras",
      "desc": "¿No te gusta un rincón? Píntalo sobre el resultado y dile a la IA qué poner. El resto queda idéntico píxel a píxel."
    },
    {
      "icon": "auto_awesome",
      "title": "Pruébalo ahora mismo",
      "desc": "Créditos gratis cada día. Sube una foto y tu primer diseño estará listo en un minuto."
    }
  ],
  "onboardTabFeedTitle": "Explora primero",
  "onboardTabFeedDesc": "Mira lo que otros crearon y encuentra inspiración para tu espacio.",
  "onboardTabCreateTitle": "Diseña con IA",
  "onboardTabCreateDesc": "Sube una foto, boceto o plano — la IA genera un diseño nuevo.",
  "onboardTabMyTitle": "Guarda y gestiona",
  "onboardTabMyDesc": "Tus diseños se reúnen aquí. Compártelos o descárgalos cuando quieras.",
  "onboardTabGioTitle": "Pregunta a Gio",
  "onboardTabGioDesc": "Gio, nuestro diseñador de espacios, sugiere estilos desde tus fotos y puede crear o editar diseños directamente en el chat.",
  "myDesignsTitle": "Mis diseños",
  "signInToSee": "Inicia sesión para ver tus diseños",
  "signInToSeeDesc": "Tus diseños guardados aparecerán aquí.",
  "loadingDesigns": "Cargando diseños…",
  "errLoadDesigns": "No se pudieron cargar. Inténtalo de nuevo.",
  "retry": "Reintentar",
  "noFavorites": "Aún no hay favoritos.",
  "noDesigns": "¡Aún no hay diseños. Crea el primero!",
  "createDesign": "Crear un diseño",
  "loadMore": "Cargar más",
  "loading": "Cargando…",
  "errDesignNotFound": "Diseño no encontrado.",
  "errLoadDesign": "No se pudo cargar el diseño.",
  "errDeleteDesign": "No se pudo eliminar. Inténtalo de nuevo.",
  "renameTitle": "Renombrar diseño",
  "renamePlaceholders": [
    "Salón v1",
    "Cocina — versión luminosa",
    "Reforma del estudio",
    "Dormitorio, tonos cálidos",
    "Balcón plan B",
    "Despacho en casa",
    "Borrador de cafetería",
    "Jardín delantero v2"
  ],
  "save": "Guardar",
  "cancel": "Cancelar",
  "deleteTitle": "¿Eliminar diseño?",
  "deleteDesc": "Elimina permanentemente este diseño y todas sus imágenes. No se puede deshacer.",
  "delete": "Eliminar",
  "deleting": "Eliminando…",
  "postToFeed": "Publicar en el feed",
  "postedToFeedTitle": "Publicado en el feed",
  "postedToFeedDesc": "Otros usuarios ya pueden ver y dar me gusta a este diseño.",
  "captionTitle": "Añade una descripción",
  "captionPlaceholder": "Cuenta por qué rediseñaste este espacio (opcional)",
  "captionEdit": "Editar descripción",
  "captionPost": "Publicar",
  "captionSave": "Guardar",
  "captionCancel": "Cancelar",
  "viewFeed": "Ver el feed",
  "generationInProgress": "Diseñando tu espacio…",
  "generationKeepBrowsing": "Sigue navegando — te avisaremos cuando esté listo",
  "generationDone": "¡Tu diseño está listo!",
  "generationTapToOpen": "Toca Abrir para verlo",
  "generationFailedHint": "No se te cobró el crédito. Inténtalo de nuevo.",
  "open": "Abrir",
  "copy": "Copiar",
  "copied": "¡Copiado!",
  "share": "Compartir",
  "downloadImages": "Descargar imágenes IA",
  "download": "Descargar",
  "downloadWatermarkHint": "Una pequeña firma de archelier aparece abajo a la derecha.",
  "modes": {
    "redesign": "Rediseño",
    "staging": "Staging de habitación vacía"
  },
  "styleUsed": "Estilo usado",
  "customDescLabel": "Descripción personalizada:",
  "additionalReqLabel": "Peticiones adicionales:",
  "useStyleAgain": "Volver a usar este estilo",
  "feedTitle": "Comunidad",
  "feedEmpty": "Aún no hay diseños públicos. ¡Sé el primero!",
  "feedSortLatest": "Recientes",
  "feedSortPopular": "Populares",
  "feedFilterAll": "Todos",
  "useThisStyle": "Probar este estilo",
  "sourceDesignBanner": "Basado en «{name}»",
  "galleryPickBanner": "Creando con {name}",
  "signInToLike": "Inicia sesión para dar me gusta",
  "tryApp": "Probar archelier",
  "privateTitle": "Este diseño es privado",
  "privateDesc": "El propietario no lo ha hecho público.",
  "linkNotFoundTitle": "Este enlace no está disponible",
  "linkNotFoundDesc": "Puede que el diseño se haya eliminado o que el enlace esté incompleto.",
  "createWithApp": "Crear con archelier",
  "shareViewCTA": "¿Quieres rediseñar tu propio espacio?",
  "styles": {
    "modern": {
      "name": "Moderno",
      "description": "Líneas limpias, tonos neutros, contemporáneo minimalista"
    },
    "scandinavian": {
      "name": "Escandinavo",
      "description": "Luminoso, materiales naturales, calidez nórdica"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Funcional, asequible, diseño escandinavo cotidiano"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Minimalismo japonés con calidez escandinava"
    },
    "industrial": {
      "name": "Industrial",
      "description": "Materiales en bruto, elementos vistos, estética loft"
    },
    "coastal": {
      "name": "Costero",
      "description": "Elegancia de casa de playa, fresca y luminosa"
    },
    "classic": {
      "name": "Clásico",
      "description": "Elegancia atemporal, telas ricas, detalles ornamentados"
    },
    "artdeco": {
      "name": "Art déco",
      "description": "Geometría audaz, acentos dorados, glamour años 20"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Formas orgánicas, madera cálida, encanto retro 1950-60"
    },
    "maximalist": {
      "name": "Maximalista",
      "description": "Patrones atrevidos, capas ricas, más es más"
    },
    "vintage": {
      "name": "Vintage",
      "description": "Encanto nostálgico, hallazgos antiguos, paleta retro"
    },
    "bohemian": {
      "name": "Bohemio",
      "description": "Espíritu libre, textiles coloridos, eclecticismo artístico"
    },
    "tropical": {
      "name": "Tropical",
      "description": "Vegetación exuberante, ratán, aire de resort"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Campiña inglesa romántica, flores, pasteles suaves"
    },
    "rustic": {
      "name": "Rústico",
      "description": "Madera envejecida, piedra, encanto de granja"
    },
    "wabisabi": {
      "name": "Wabi-sabi",
      "description": "Belleza imperfecta, texturas crudas, ascetismo japonés"
    },
    "gothic": {
      "name": "Gótico",
      "description": "Drama oscuro, terciopelo, siluetas ornamentadas"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Futurismo de neón, superficies hi-tech, distopía urbana"
    },
    "taisho_romance": {
      "name": "Taishō Romance",
      "description": "Japón de principios del XX con Art Nouveau occidental"
    },
    "biophilic": {
      "name": "Biofílico",
      "description": "Plantas por doquier, luz natural, texturas orgánicas"
    },
    "cozy": {
      "name": "Acogedor",
      "description": "Cálido, suave, hospitalario — confort hygge"
    },
    "gaming": {
      "name": "Gaming",
      "description": "Setup RGB, tecnología elegante, battlestation inmersiva"
    },
    "minimalist": {
      "name": "Minimalista",
      "description": "Despojado, sin desorden, espacio negativo"
    },
    "mediterranean": {
      "name": "Mediterráneo",
      "description": "Cal, terracota, arcos y piedra natural"
    },
    "luxury": {
      "name": "Lujo silencioso",
      "description": "Materiales nobles, paleta contenida"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Biblioteca sombría — burdeos, latón, libros"
    },
    "organic_modern": {
      "name": "Moderno orgánico",
      "description": "Formas modernas en material natural"
    },
    "farmhouse": {
      "name": "Farmhouse",
      "description": "Tablillas, fregadero de delantal, madera envejecida"
    },
    "halloween": {
      "name": "Halloween",
      "description": "Calabazas, velas, otoño sombrío"
    },
    "christmas": {
      "name": "Navidad",
      "description": "Árbol, guirnaldas, luces cálidas"
    },
    "lunar_new_year": {
      "name": "Año Nuevo Lunar",
      "description": "Rojo y dorado, farolillos, motivos de fortuna"
    },
    "spring_blossom": {
      "name": "Primavera en flor",
      "description": "Cerezos, pasteles, luz fresca"
    },
    "custom": {
      "name": "Estilo personalizado",
      "description": "Describe tu propia visión de interior"
    },
    "reference": {
      "name": "Referencia",
      "description": "Imita los tonos, materiales y ambiente de una foto tuya"
    },
    "floorplan": {
      "name": "Plano",
      "description": "Un plano 3D o un dibujo en limpio a partir de tu plano"
    },
    "cleanup": {
      "name": "Ordenar",
      "description": "Ordenar el desorden o vaciar la habitación — tú eliges"
    },
    "layout": {
      "name": "Distribución",
      "description": "Mismos muebles, mejor colocación — circulación o amplitud"
    }
  },
  "langMismatchNotice": "Este análisis se generó en {lang}.",
  "pricingTitle": "Planes que crecen contigo",
  "pricingSubtitle": "Empieza gratis. Mejora cuando necesites más generaciones y funciones premium.",
  "pricePerMonth": "/ mes",
  "trialCta": "Prueba gratis de {n} días",
  "accountPlanFreeTitle": "Tu cuenta es GRATIS",
  "accountPlanProTitle": "Estás en Pro",
  "accountPlanTrialTitle": "Estás en Pro — prueba gratis",
  "proTrialBadge": "Prueba",
  "proTrialDaysLeft": "Te quedan {n} días de prueba gratis",
  "proTrialIntroTitle": "2 semanas de Pro — gratis",
  "proTrialIntroDesc": "Regístrate y empieza con {n} créditos gratis.",
  "proTrialFeatures": "Luego {n} más gratis cada día. Sin suscripción, nunca.",
  "welcomeSkip": "Continuar sin cuenta",
  "landingHeadline": "rediseña cualquier espacio, en segundos.",
  "landingTagline": "Una foto, un estilo, un render fotorrealista. Gratis cada día, sin suscripción.",
  "landingOpenWeb": "O continúa en la web →",
  "landingFeat1": "Renders de interior IA",
  "landingFeat2": "Fotorrealista",
  "landingFeat3": "50+ estilos",
  "landingFeat4": "Jardín y exterior",
  "landingFeat5": "Gratis cada día",
  "landingStoreOn": "Descárgala en el",
  "landingStoreGet": "Disponible en",
  "lp": {
    "metaTitle": "archelier — Diseño de interiores con IA a partir de una foto, boceto o plano",
    "metaDescription": "Toma una foto de cualquier habitación y obtén un rediseño fotorrealista en un minuto. 48 estilos para interiores, exteriores y jardines, planos 3D, edición con pincel y un diseñador con IA para chatear. Gratis cada día.",
    "heroEyebrow": "Diseño de interiores con IA",
    "scrollCue": "Mira cómo funciona",
    "webCta": "Pruébalo gratis en tu navegador",
    "orApp": "O descarga la app",
    "qrHint": "Escanea con la cámara de tu teléfono. La app te avisará en cuanto tu diseño esté listo.",
    "showEyebrow": "Antes y después",
    "showTitle": "Una foto. Una habitación totalmente nueva.",
    "showBody": "Resultados reales, creados con archelier. Arrastra para comparar.",
    "before": "Antes",
    "after": "Después",
    "tabRoom": "Salón",
    "tabEmpty": "Habitación vacía",
    "tabSketch": "Boceto",
    "tabPlan": "Plano",
    "tabExterior": "Exterior",
    "capRoom": "Rústico: la misma cocina y salón, con más calidez.",
    "capEmpty": "Escandinavo: una habitación vacía, amueblada.",
    "capSketch": "Japandi: un boceto a mano, renderizado como un espacio real.",
    "capPlan": "Modo plano: un plano en 2D convertido en una vista 3D de toda la casa.",
    "capExterior": "Minimalista: un escaparate recargado, rediseñado.",
    "howEyebrow": "Cómo funciona",
    "howTitle": "Tres pasos, un minuto.",
    "how1Title": "Toma una foto",
    "how1Body": "Cualquier habitación, tal cual — o un boceto, un plano o una captura 3D. Hasta 3 ángulos del mismo espacio.",
    "how2Title": "Elige un estilo",
    "how2Body": "Elige uno de los 48 estilos, describe el tuyo en una frase o sube una foto cuyo estilo te encante.",
    "how3Title": "Consigue tu diseño",
    "how3Body": "Un render fotorrealista de tu espacio, con lista de muebles, paleta de colores y plan de iluminación.",
    "stylesEyebrow": "Estilos",
    "stylesTitle": "48 estilos, tres tipos de espacio.",
    "stylesBody": "28 para interiores, 11 para exteriores, 9 para jardines — además de estilos de temporada para Halloween, Navidad, Año Nuevo Chino y primavera.",
    "stylesInterior": "Interior",
    "stylesExterior": "Exterior",
    "stylesGarden": "Jardín",
    "stylesCta": "Explora la galería de estilos",
    "modesEyebrow": "Más allá de los estilos",
    "modesTitle": "Cinco formas más de trabajar en un espacio.",
    "modeCustomTitle": "Estilo personalizado",
    "modeCustomBody": "Describe el estilo en una frase y guárdalo para la próxima vez.",
    "modeReferenceTitle": "Referencia",
    "modeReferenceBody": "Sube una foto que te guste y toma prestados sus tonos, materiales y paleta — no su distribución.",
    "modeCleanupTitle": "Limpieza",
    "modeCleanupBody": "Despeja el desorden y ve la habitación vacía.",
    "modeLayoutTitle": "Distribución",
    "modeLayoutBody": "Reorganiza los muebles que ya tienes en lugar de cambiarlos.",
    "modePlanTitle": "Plano",
    "modePlanBody": "Convierte un plano en una vista 3D de toda la casa, o un boceto sencillo en un dibujo limpio.",
    "editEyebrow": "Edición con pincel",
    "editTitle": "Cambia una cosa a la vez.",
    "editBody": "¿No te convence solo el sofá? Rodéalo y escribe qué quieres poner en su lugar. archelier rediseña solo esa zona y deja el resto de la habitación intacto — lo mismo sirve para el color de la pared, alfombras, iluminación y cuadros.",
    "editPrompt": "Un sofá de cuero vintage",
    "shopTitle": "Compra lo que ves.",
    "shopBody": "Cada diseño incluye lista de muebles, paleta de colores y plan de iluminación, y cada pieza te lleva a buscar opciones parecidas.",
    "gioEyebrow": "Gio",
    "gioTitle": "Habla directamente con un diseñador.",
    "gioBody": "Gio es tu diseñador de espacios con IA, en su propia pestaña. Envía una foto de tu habitación, la imagen o enlace de un espacio que te guste o uno de tus diseños. Gio te sugiere una idea y crea o edita el diseño por ti en el chat.",
    "gioRole": "Diseñador de espacios",
    "gioUser": "Esta es mi cocina y comedor. Se siente algo fría. ¿Alguna idea?",
    "gioReply": "Añadamos capas de madera cálida, textiles suaves y luz ambiental tenue en lugar de superficies frías. Aquí tienes una propuesta para probar:",
    "gioCardTitle": "Calidez Japandi",
    "gioCardBody": "El roble natural y el yeso texturizado aportan calidez al espacio al instante.",
    "gioCardAction": "Créalo",
    "priceEyebrow": "Precios",
    "priceTitle": "Gratis cada día. Sin suscripción.",
    "price1": "Diseños gratis cada día, renovados a tu medianoche local",
    "price2": "Un bonus al crear tu cuenta",
    "price3": "Invita a un amigo y los dos obtendréis más",
    "price4": "¿Necesitas más? Recarga un pack de créditos",
    "privacyTitle": "Tus fotos son solo tuyas.",
    "privacyBody": "Tus fotos, indicaciones y diseños nunca se usan para entrenar modelos de IA ni para publicidad. Tus diseños son privados a menos que los compartas.",
    "faqTitle": "Preguntas frecuentes",
    "faq1Q": "¿Qué es archelier?",
    "faq1A": "archelier (Architect + Atelier) es una app de diseño de interiores con IA para móvil y web. Apunta con la cámara a una habitación, elige un estilo y recibe un rediseño fotorrealista de ese espacio, con cada mueble identificado y enlazado. Funciona para interiores, exteriores y jardines.",
    "faq2Q": "¿Cómo funciona?",
    "faq2A": "Haz una foto de la habitación o sube un boceto, un plano o una captura 3D. Elige uno de los 48 estilos, describe el tuyo o sube una foto de referencia. En un minuto tendrás un render fotorrealista de tu espacio, además de lista de muebles, paleta de colores y plan de iluminación.",
    "faq3Q": "¿Es gratis archelier?",
    "faq3A": "Sí. Sin suscripciones. Tienes diseños gratis cada día, renovados a tu medianoche local, además de un bonus por crear una cuenta y por invitar a un amigo. Si necesitas más, puedes comprar un pack de créditos.",
    "faq4Q": "¿Puede transformar un plano en un render 3D?",
    "faq4A": "Sí. El modo plano convierte un plano 2D en una vista 3D de toda la casa en el estilo que elijas. También puede transformar un boceto a mano o un plano borroso en un dibujo limpio o a color.",
    "faq5Q": "¿Puedo imitar el estilo de una foto que me guste?",
    "faq5A": "Sí. Elige el estilo Referencia y sube la foto de inspiración. archelier toma sus tonos, materiales y paleta y los aplica a tu habitación sin copiar la distribución.",
    "faq6Q": "¿Puedo cambiar solo una parte del diseño?",
    "faq6A": "Sí. Rodea la zona que quieras cambiar (el sofá, la alfombra, una pared) y escribe lo que prefieras. Solo se modificará esa área; el resto de la habitación se mantendrá igual.",
    "faq7Q": "¿Qué es Gio?",
    "faq7A": "Gio es el diseñador de espacios con IA de archelier. Envíale una foto de tu habitación, una imagen o enlace de un espacio que te guste o uno de tus diseños. Gio te sugerirá una idea, creará o editará el diseño en el chat y responderá a tus dudas sobre color, presupuesto e iluminación.",
    "faq8Q": "¿Se usan mis fotos para entrenar la IA?",
    "faq8A": "No. archelier no utiliza tus fotos, indicaciones ni diseños para entrenar modelos de IA ni para publicidad. Tus diseños se mantienen privados en tu cuenta a menos que los compartas.",
    "faq9Q": "¿Dónde puedo usar archelier?",
    "faq9A": "En App Store, Google Play y en la web en archelier.co. Tu cuenta y tus diseños se sincronizan en todas partes. archelier está disponible en 11 idiomas.",
    "ctaTitle": "Rediseña tu habitación hoy.",
    "ctaBody": "En tu móvil y en la web. Tus diseños sincronizados en todas partes.",
    "langLabel": "Idioma"
  },
  "upgradeToPro": "Pasar a Pro",
  "creditsPerMonth": "{n} créditos al mes",
  "planFreeName": "Gratis",
  "planFreeTagline": "Prueba archelier con algunos diseños al mes.",
  "planProName": "Pro",
  "planProTagline": "Para diseñadores habituales que quieren calidad.",
  "planStudioName": "Studio",
  "planStudioTagline": "Para usuarios intensivos, equipos y uso comercial.",
  "planFeatWatermark": "Incluye marca de agua «archelier»",
  "planFeatNoWatermark": "Sin marca de agua en diseños guardados o compartidos",
  "planFeatUnlimited": "Generaciones de diseño IA ilimitadas",
  "planFeatUnlimitedChat": "Chat IA ilimitado por diseño (gratis: 3 turnos)",
  "planFeatUnlimitedEdit": "Ediciones de zona ilimitadas",
  "planFeatFeed": "Compartir en el feed",
  "planFeatEverythingPro": "Todo lo de Pro",
  "planFeatCommercial": "Derechos de uso comercial",
  "planFeatApiAccess": "Acceso API (próximamente)",
  "planCtaSubscribe": "Suscribirse",
  "planCtaCurrent": "Tu plan actual",
  "planPopular": "El más popular",
  "signInToSubscribe": "Inicia sesión para suscribirte",
  "signInToBuy": "Inicia sesión para comprar",
  "trialNote": "Prueba gratis de {n} días",
  "creditPacksTitle": "O recarga con packs de créditos",
  "creditPacksSubtitle": "Compra única, sin suscripción.",
  "packStarterName": "Pack Starter",
  "packStandardName": "Pack Estándar",
  "packProName": "Pack Pro",
  "packCreditsAmount": "{n} créditos",
  "packCtaBuy": "Comprar",
  "pricingFootnote": "Precios en USD. Impuestos al pagar. Cancela cuando quieras.",
  "errBillingGeneric": "Algo salió mal al procesar tu solicitud. Inténtalo de nuevo.",
  "accountTitle": "Ajustes",
  "accountPlanSection": "Suscripción",
  "accountCreditsSection": "Créditos",
  "accountCreditsDesc": "Los créditos se consumen al generar diseños. Recarga cuando quieras.",
  "viewPlans": "Ver planes",
  "changePlan": "Cambiar de plan",
  "manageBilling": "Gestionar facturación",
  "manageBillingWebHint": "Si te suscribiste en la web, gestiónalo en archelier.co.",
  "buyCreditPack": "Comprar pack de créditos",
  "subRenewsAt": "Se renueva el {date}",
  "subEndsAt": "Termina el {date}",
  "trialEndsAt": "La prueba gratis termina el {date} — pasa automáticamente a 9,99 $/mes",
  "trialCancelEndsAt": "La prueba termina el {date} — la suscripción no se renovará",
  "subStatus_past_due": "Pago atrasado — actualiza tu método de pago.",
  "subStatus_canceled": "Suscripción cancelada.",
  "subStatus_unpaid": "Suscripción impagada.",
  "subStatus_trialing": "Prueba gratis activa.",
  "account": "Cuenta",
  "pricing": "Precios",
  "upgrade": "Mejorar",
  "inviteTitle": "Invita amigos y gana créditos",
  "inviteSubtitle": "Cuando un amigo se registra con tu enlace, tú recibes +{inviter} créditos y él +{invitee}.",
  "inviteFriends": "Invitar amigos",
  "inviteSignInHint": "Inicia sesión para obtener tu enlace personal.",
  "yourReferralCode": "Tu enlace de invitación",
  "inviteCodeLoading": "Preparando tu enlace…",
  "inviteLinkHint": "Los registros con tu enlace reciben +{n} créditos iniciales.",
  "copyLink": "Copiar enlace",
  "shareLink": "Compartir enlace",
  "inviteShareText": "Rediseña tu espacio con IA en archelier. Con mi enlace recibes +{n} créditos gratis.",
  "redeemTitle": "¿Tienes un código?",
  "redeemDesc": "Introduce un código de invitación o promocional para recibir créditos bonus.",
  "copyCode": "Copiar código",
  "errRefSelf": "No puedes usar tu propio código.",
  "landingInviteTitle": "Un amigo te invitó — ambos reciben +{n} créditos.",
  "landingInviteAutoIos": "Instala la app y vuelve a tocar este enlace de invitación — la app se abrirá y tu bono se añadirá al registrarte.",
  "landingInviteAutoAndroid": "Instala la app desde el botón de Google Play de abajo y regístrate — tu bono se añadirá automáticamente. Si no, introduce este código en Ajustes → Invitar amigos.",
  "landingInviteDesktop": "Regístrate aquí y tu bono se añadirá al instante. Para tenerlo en la app del móvil, escanea el código QR y sigue los pasos en tu teléfono.",
  "promoTitle": "¿Un código promocional?",
  "promoDesc": "Introduce un código promocional para recibir créditos bonus.",
  "promoPlaceholder": "ej. LAUNCH2026",
  "promoRedeem": "Canjear",
  "promoSuccess": "Canjeado — {n} créditos añadidos a tu cuenta.",
  "errPromoInvalid": "Ese código no es válido.",
  "errPromoExpired": "Este código ha caducado.",
  "errPromoMaxed": "Este código alcanzó su límite de uso.",
  "errPromoUsed": "Ya has canjeado este código.",
  "errPromoUserInit": "Recarga la página e inténtalo de nuevo.",
  "errPromoGeneric": "No se pudo canjear el código. Inténtalo de nuevo.",
  "reportThisDesign": "Denunciar este diseño",
  "reportShort": "Denunciar",
  "reportTitle": "Denunciar diseño",
  "reportDesc": "¿Qué problema tiene? Solo los moderadores ven tu denuncia.",
  "reportReason_spam": "Spam o publicidad",
  "reportReason_nsfw": "Contenido sexual o inapropiado",
  "reportReason_copyright": "Infracción de derechos de autor",
  "reportReason_other": "Otro",
  "reportNotePlaceholder": "Añade detalles (opcional, máx. 500 caracteres)",
  "reportSubmit": "Enviar denuncia",
  "reportSubmitting": "Enviando…",
  "reportSignInHint": "Inicia sesión para denunciar.",
  "reportThanks": "Denuncia recibida",
  "reportThanksDesc": "Lo revisaremos y actuaremos si procede. Gracias por avisar.",
  "errReportGeneric": "No se pudo enviar la denuncia. Inténtalo en un momento.",
  "blockUser": "Bloquear a este usuario",
  "unblockUser": "Desbloquear",
  "blockShort": "Bloquear",
  "blockConfirm": "¿Bloquear a @{handle}? No verás sus diseños ni su actividad, y no podrá interactuar con los tuyos.",
  "blockedUsersMenu": "Usuarios bloqueados",
  "blockedUsersTitle": "Usuarios bloqueados",
  "blockedUsersDesc": "Usuarios que has bloqueado. Sus diseños quedan ocultos.",
  "blockedUsersEmpty": "No has bloqueado a nadie.",
  "profileBlocked": "Has bloqueado a este usuario.",
  "profileBlockedAction": "Desbloquéalo para volver a ver sus diseños.",
  "errBlockGeneric": "No se pudo actualizar el bloqueo. Inténtalo de nuevo.",
  "errBlockedCustomCommand": "Tu petición contiene palabras no permitidas.",
  "moderationAutoUnlisted": "Este diseño fue retirado automáticamente del feed público por nuestra moderación. Si crees que es un error, contacta con los administradores.",
  "promptLang": "Spanish"
};
